<!-- prettier-ignore -->

<div class="addition-info-container">
    @if(isSaveRoute()){
        <div class="form-group-update-route" >
            <label class="labels">
                <span>{{ 'Nombre de la ruta' | translate }}</span> *
            </label>
            @for(lang of tools.languages(); track lang) {
                <div class="input-wrapper" [ngClass]="{'hidden': translate.currentLang != lang.code}">
                    <input #input autocomplete="off" (focusin)="focusin($event)" type="text" (keyup)="insertText(input.value, lang.code)" [value]="routeName?.[translate.currentLang] || ''" />
                </div>
            }
        </div>
    }

    <textarea #additionalInfoTextArea class="addition-info-container__text-area" [value]="additionalInfo()" [placeholder]="'Notas de Viaje' | translate" [ngClass]="{'only-textarea': !isSaveRoute()}"></textarea>
    <div class="addition-info-container__action-buttons">
        <button (click)="goBack()" class="back-button">{{'Volver' | translate}}</button>
    
        <button (click)="update(additionalInfoTextArea.value)" class="confirm-button" [ngClass]="{'loader' : updatingRoute()}" [disabled]="updatingRoute()">
            @if(updatingRoute()){
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style="height: 40px; width: 40px; position: absolute;">
                    <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                        <stop offset="0" stop-color="#FFFFFF"></stop>
                        <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                        <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                        <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                        <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
                    </radialGradient>
                    <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="40" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
                        <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
                    </circle>
                    <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="40" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                </svg>
            }
            @else {
                {{ 'Actualizar' | translate}}            
            }
        </button>

    </div>
</div>